import React, {useMemo} from 'react';
import Form from '../../components/Form';
import Grid from '../../components/Grid';
import Badge from '../../components/Badge';

const CustomerDescriptionsTable = (props) => {

  const data = props.items || [];

  const columns = useMemo(
      () => [
          {
              Header: <span>Customer <Badge className='float-right mr-1 mt-1' variant='info'>{data.length}</Badge></span>,
              accessor: 'customer',
              Cell: cellInfo => { 
                return cellInfo.row.original.custDescId
                ? <Form.Link to={'/customerdescription/' + cellInfo.row.original.custDescId} value={cellInfo.cell.value.name} />
                : cellInfo.cell.value.name;
              }
          },
      ],
      [data.length]
  )
  return (
      <div id='customer-desc-results'>
          <Grid id='results-table' showPagination={false} columns={columns} data={data}  />
      </div>     
  );
}

export default CustomerDescriptionsTable;